import { useAppContext } from '../../app/Context';

const useAppError = () => {
  const { error, setError } = useAppContext();

  const handleClose = () => setError('');

  return { error, handleClose };
};

export default useAppError;
